import type { PerformanceConfig } from "./schema";
import { BASE_PACK } from "./base";
import { SENIOR_LIVING_VISIT_FORM } from "./visitForms";

/** Senior-living vocabulary from the wireframe (`wireframe/data.js:11-17`, `views-settings.js`). */
export const SENIOR_LIVING_PACK: PerformanceConfig = {
  ...BASE_PACK,
  vertical: "senior_living",
  levels: {
    staff: "Team member",
    dept: "Department head",
    community: "Executive Director",
    regional: "Regional Director",
    corporate: "Corporate",
  },
  terms: {
    coaching: "Coaching",
    pip: "Performance Improvement Plan",
    pipShort: "PIP",
    eval: "Annual evaluation",
    visit: "Site visit",
    site: "Community",
  },
  // E5 R1: the client's Regional Director visit (wireframe data.js:848-849).
  visits: { ...BASE_PACK.visits, forms: [SENIOR_LIVING_VISIT_FORM] },
  plans: {
    ...BASE_PACK.plans,
    levelHeading: "Level of discipline",
    actionExample: "Wear full uniform and badge every shift",
  },
  // E9 (views-settings.js:102): the 10-year choice matches the care records' own retention.
  retention: { ...BASE_PACK.retention, matchingRecords: "clinical and resident records" },
  // The wireframe's hints are shift-work words; the neutral base pack has its own (PR #1314).
  coachingTypes: BASE_PACK.coachingTypes.map((t) =>
    t.key === "site_visit"
      ? { ...t, description: "The community walk-through. Regional and up." }
      : t.key === "recognition"
        ? { ...t, titleHint: "Covered two open shifts" }
        : t.key === "coaching_discussion"
          ? { ...t, titleHint: "Uniform and name badge" }
          : t,
  ),
  syncFields: [
    "Reporting line",
    "Job title",
    "Community",
    "Department",
    "Start date",
    "Employment status",
  ],
  defaultPositionMappings: [
    ...BASE_PACK.defaultPositionMappings,
    { pattern: "vp *", roleName: "perf_manager", levelKey: "corporate" },
    {
      pattern: "vice president*",
      roleName: "perf_manager",
      levelKey: "corporate",
    },
    {
      pattern: "regional director*",
      roleName: "perf_manager",
      levelKey: "regional",
    },
    {
      pattern: "executive director",
      roleName: "perf_manager",
      levelKey: "community",
    },
    {
      pattern: "director of nursing",
      roleName: "perf_manager",
      levelKey: "dept",
    },
    { pattern: "* director", roleName: "perf_manager", levelKey: "dept" },
    {
      pattern: "business office manager",
      roleName: "perf_manager",
      levelKey: "dept",
    },
    {
      pattern: "resident assistant",
      roleName: "perf_employee",
      levelKey: "staff",
    },
    {
      pattern: "medication technician",
      roleName: "perf_employee",
      levelKey: "staff",
    },
    { pattern: "dining server", roleName: "perf_employee", levelKey: "staff" },
    { pattern: "housekeeper", roleName: "perf_employee", levelKey: "staff" },
  ],
};
